export default __webpack_public_path__ + "./images/gd.9bcac326.png";